import { lazy } from "react";
import { Home as HomeIcon, Store } from "lucide-react";
import type { AreaRoutes } from "./types";

const Home = lazy(() => import("../pages/Home"));
const Stores = lazy(() => import("../pages/Stores"));

export const stores: AreaRoutes = {
  routes: [
    { path: "/home", element: <Home /> },
    { path: "/stores", element: <Stores /> },
  ],
  nav: [
    { to: "/home", label: "Home", icon: HomeIcon },
    { to: "/stores", label: "Stores", icon: Store },
  ],
};
